import { CompRef } from '@wix/document-services-types';
import {
  EditorPointer,
  EditorPointerServiceAPI,
} from '@wix/editor-document-logic-api';

export function generateUniqueId(
  editorPointerAPI: EditorPointerServiceAPI,
  editorPointer: EditorPointer<CompRef>,
  cssPropertyKey?: string,
): string {
  const editorPointerUniqueId = editorPointerAPI.getEditorPointerUniqueId(
    editorPointerAPI.getDocumentPointer(editorPointer),
    editorPointerAPI.getInnerElementPath(editorPointer),
  );

  if (cssPropertyKey) {
    return `${editorPointerUniqueId}/${cssPropertyKey}`;
  }

  return editorPointerUniqueId;
}
